import { createReducer } from "../ReduxHelpers";
import { FETCH_ORGANIZATION_SUBSCRIPTION_BEGIN } from "./UserActions";

const userInitialState = {
  userId: null,
  memberships: [],
  loading: false,
  error: false,
  primaryOrg: null,
};
function setUser(state, action) {
  let newState = { ...state };
  newState.username = action.payload?.username;
  newState.email = action.payload?.attributes?.email;
  newState.primaryOrgId = action.payload?.attributes["custom:primary_org"];
  return newState;
}
function fetchUserBegin(state, action) {
  let newState = Object.assign({}, state);
  newState.loading = true;
  newState.error = false;
  return newState;
}

function fetchUserSuccess(state, action) {
  let newState = Object.assign({}, state);
  newState.loading = false;
  newState.error = false;
  newState.userId = action.payload.getUser.id;
  newState.userSub = action.payload.getUser.attributes?.sub;
  newState.username = action.payload.getUser.username;
  newState.email = action.payload.getUser.email;
  newState.memberships = [...(action.payload.getUser.memberships || [])];
  newState.primaryOrg = { ...action.payload.getUser.primaryOrg };
  newState.subscription = {...action.payload.getUser.subscription}; 
  return newState;
}

function fetchUserFailure(state, action) {
  let newState = Object.assign({}, state);
  newState.loading = false;
  newState.error = true;
  return newState;
}

function fetchOrganizationBegin(state, action) {
  let newState = Object.assign({}, state);
  newState.loading = true;
  newState.error = false;
  return newState;
}

function fetchOrganizationSuccess(state, action) {
  let newState = Object.assign({}, state);
  newState.loading = false;
  newState.primaryOrg = { ...action.payload.getOrganization };
  return newState;
}

function fetchOrganizationFailure(state, action) {
  let newState = Object.assign({}, state);
  newState.loading = false;
  newState.error = true;
  newState.errorMessage = action.payload;
  return newState;
}

function fetchOrganizationStatBegin(state, action) {
  let newState = Object.assign({}, state);
  newState.loading = true;
  newState.error = false;
  return newState;
}

function fetchOrganizationStatSuccess(state, action) {
  let newState = Object.assign({}, state);
  newState.loading = false;
  newState.orgStat = { ...action.payload.getOrganizationStat };
  return newState;
}

function fetchOrganizationStatFailure(state, action) {
  let newState = Object.assign({}, state);
  newState.loading = false;
  newState.error = true;
  newState.errorMessage = action.payload;
  return newState;
}

function updateOrganizationBegin(state, action) {
  let newState = Object.assign({}, state);
  newState.saveOrgInProgress = true;
  newState.saveOrgError = false;
  newState.saveOrgErrorMessage = "";
  return newState;
}

function updateOrganizationSuccess(state, action) {
  let newState = Object.assign({}, state);
  newState.primaryOrg = { ...action.payload.updateOrganization };
  newState.saveOrgInProgress = false;
  newState.saveOrgError = false;
  newState.saveOrgErrorMessage = "";
  return newState;
}

function updateOrganizationFailure(state, action) {
  let newState = Object.assign({}, state);
  newState.saveOrgInProgress = false;
  newState.saveOrgError = true;
  newState.saveOrgErrorMessage = action.payload;
  return newState;
}

function fetchOrgSubscriptionBegin(state, action) {
  let newState = Object.assign({}, state);
  newState.error = false;
  return newState;
}

function fetchOrgSubscriptionSuccess(state, action) {
  let newState = Object.assign({}, state);
  newState.subscription = action.payload.getOrganizationSubscription;
  return newState;
}

function fetchOrgSubscriptionFailure(state, action) {
  let newState = Object.assign({}, state);
  newState.error = true;
  newState.errorMessage = action.payload;
  return newState;
}

function fetchOrganizationDepositsBegin(state, action) {
  let newState = Object.assign({}, state);
  newState.fetchDepositsInProgress = true;
  newState.fetchDepositsError = false;
  newState.fetchDepositsErrorMessage = "";
  
  return newState;
}

function fetchOrganizationDepositsSuccess(state, action) {
  let newState = Object.assign({}, state);
  newState.fetchDepositsInProgress = false;
  newState.deposits = action.payload.listOrganizationDeposits?.items || [];
  newState.fetchDepositsError = false;
  newState.fetchDepositsErrorMessage = "";
  newState.fetchDepositsNextToken = action.payload.listOrganizationDeposits?.nextToken;
  return newState;
}

function fetchOrganizationDepositsFailure(state, action) {
  let newState = Object.assign({}, state);
  newState.fetchDepositsInProgress = false;
  newState.fetchDepositsError = true;
  newState.fetchDepositsErrorMessage = action.payload;
  newState.deposits = [];
  return newState;
}

export const userReducers = createReducer(userInitialState, {
  FETCH_USER_BEGIN: fetchUserBegin,
  FETCH_USER_SUCCESS: fetchUserSuccess,
  FETCH_USER_FAILURE: fetchUserFailure,
  SET_USER_ACTION: setUser,
  FETCH_ORGANIZATION_BEGIN: fetchOrganizationBegin,
  FETCH_ORGANIZATION_SUCCESS: fetchOrganizationSuccess,
  FETCH_ORGANIZATION_FAILURE: fetchOrganizationFailure,
  UPDATE_ORGANIZATION_BEGIN_ACTION: updateOrganizationBegin,
  UPDATE_ORGANIZATION_SUCCESS_ACTION: updateOrganizationSuccess,
  UPDATE_ORGANIZATION_FAILURE_ACTION: updateOrganizationFailure,
  FETCH_ORGANIZATION_STAT_BEGIN: fetchOrganizationStatBegin,
  FETCH_ORGANIZATION_STAT_SUCCESS: fetchOrganizationStatSuccess,
  FETCH_ORGANIZATION_STAT_FAILURE: fetchOrganizationStatFailure,
  FETCH_ORGANIZATION_SUBSCRIPTION_BEGIN: fetchOrgSubscriptionBegin,
  FETCH_ORGANIZATION_SUBSCRIPTION_SUCCESS: fetchOrgSubscriptionSuccess,
  FETCH_ORGANIZATION_SUBSCRIPTION_FAILURE: fetchOrgSubscriptionFailure,
  FETCH_ORGANIZATION_DEPOSITS_BEGIN: fetchOrganizationDepositsBegin,
  FETCH_ORGANIZATION_DEPOSITS_SUCCESS: fetchOrganizationDepositsSuccess,
  FETCH_ORGANIZATION_DEPOSITS_FAILURE: fetchOrganizationDepositsFailure,
});
